import Vue from "vue";
import moment from "moment/moment";

import i18n from "@/locales/index";

export default class ConvertService extends Vue {

    public static objToArray(obj: any) {

        let ret: any = [];

        for (let key in obj) {

            ret.push(obj[key]);

        }

        return ret;

    }

    public static dbResultsToSelectOptions(results: Array<any>, textColumn: string, valueColumn: string, htmlTextColumn: string = '') {

        return results.map((result) => {

            return {

                text: result[textColumn],
                value: result[valueColumn],
                htmlText: result[htmlTextColumn],
                selected: false

            }

        });

    }

    public static secondsToDateString(seconds: number, showHours: boolean = true, showMinutes: boolean = true, showSeconds: boolean = false): string {

        let runningTime: string = '';

        runningTime += showHours ? String(moment.duration(seconds, 'seconds').hours()) + ' ' + i18n.tc('common_words.hours', seconds) + ' ' : '';

        runningTime += showMinutes ? String(moment.duration(seconds, 'seconds').minutes()) + ' ' + i18n.tc('common_words.minutes', seconds) + ' ' : '';

        runningTime += showSeconds ? String(moment.duration(seconds, 'seconds').seconds()) + ' ' + i18n.tc('common_words.seconds', seconds) + ' ' : '';

        return runningTime;

    }

    public static secondsToShortDateString(seconds: number, showHours: boolean = true, showMinutes: boolean = true, showSeconds: boolean = false): string {

        let runningTime: string = '';

        runningTime += showHours ? String(moment.duration(seconds, 'seconds').hours()) : '';

        if (showMinutes) {

            let minutes: number = moment.duration(seconds, 'seconds').minutes();

            runningTime += ':' + ((minutes < 10) ? '0' : '') + String(minutes);

        }

        if (showSeconds) {

            let seconds_left: number = moment.duration(seconds, 'seconds').seconds();

            runningTime += ':' + (seconds_left < 10) ? '0' : '' + String(seconds_left);

        }


        return runningTime;

    }


}